import { useContext } from 'react';
import { Layer } from '@/layers/LayerContext.tsx';

export const useLayer = () => {
  return useContext(Layer);
};
